import { Flex, type FlexProps } from '@mantine/core'
import { MRT_Header, MRT_RowData, MRT_TableInstance } from 'mantine-react-table'
import { TableFilterInput } from './TableFilterInput'
import styles from './TablePlaceFilterInput.module.css'

interface Props<TData extends MRT_RowData> extends FlexProps {
  header: MRT_Header<TData>
  table: MRT_TableInstance<TData>
}

export function TablePlaceFilterInput<TData extends MRT_RowData>({ header, table, ...rest }: Props<TData>) {
  const props = {
    header,
    table,
    allowNegative: false,
    allowDecimal: false,
    clampBehavior: 'strict',
    hideControls: true,
    withAsterisk: true,
    variant: 'unstyled',
    style: { fontWeight: 'normal', borderBottom: '2px solid var(--mantine-color-gray-3)' },
    classNames: { input: styles.input },
  } as const

  return (
    <Flex gap="xs" {...rest}>
      <TableFilterInput {...props} rangeFilterIndex={0} placeholder="1" />
      <TableFilterInput {...props} rangeFilterIndex={1} placeholder="2" />
      <TableFilterInput {...props} rangeFilterIndex={2} placeholder="3" />
    </Flex>
  )
}
